import { Box, Card, TablePagination } from '@mui/material';
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import SearchBar from '../../../common/search-bar/search-bar';
import { EmployeeType } from '../create-employee-form/create-employee-form.interfaces';
import EmployeesListingTable from './employees-listing.table';
import { PaginationContext } from '../../../../contexts/pagination-context';
import useRoles from '../../../../hooks/roles';

function EmployeesListing() {
  const navigate = useNavigate();
  
  const [employeesList, setEmployeesList] = useState<EmployeeType[]>([]);
  const [employeesCount, setEmployeesCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);


  const searchOptions = ['Name', 'Phone'];

  const { paginationConfig, setPaginationConfig } =
    useContext(PaginationContext);

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: paginationConfig.rowsPerPage,
    searchColumn: 'Name',
    searchValue: '',
    searchOperation: 'equals',
  });

  const { user, config } = useContext(AuthContext);

  useEffect(() => {
    const getData = async () => {
      let endpoint = `${API_ENDPOINT}/api/org/employees?page=${controller.page + 1}&page_size=${controller.rowsPerPage}`;

      if (controller.searchColumn !== '' && controller.searchValue !== '') {
        endpoint += `&${controller.searchColumn.toLowerCase()}__${controller.searchOperation}=${encodeURIComponent(controller.searchValue)}`;
      }
      try {
        const response = await axios.get<{
          count: number;
          results: EmployeeType[];
        }>(endpoint, config);
        const data = response.data;
        setEmployeesList(data.results);
        setEmployeesCount(data.count);
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    };
    setIsLoading(true);
    getData();
  }, [controller]);

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setPaginationConfig({ ...paginationConfig, rowsPerPage: newRowsPerPage });
    setController({
      ...controller,
      rowsPerPage: newRowsPerPage,
      page: 0,
    });
  };

  const searchQueryAction = (
    column: string,
    value: string,
    operation: string
  ) => {
    setController({
      ...controller,
      page: 0,
      searchColumn: column,
      searchValue: value,
      searchOperation: operation,
    });
  };

  return (
    <Box>
      <SearchBar
        searchOptions={searchOptions}
        searchQueryAction={searchQueryAction}
      />
      <EmployeesListingTable employees={employeesList} isLoading={isLoading} />
      <TablePagination
        component="div"
        onPageChange={handlePageChange}
        page={controller.page}
        count={employeesCount}
        rowsPerPage={controller.rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 250, 500, 1000]}
        labelRowsPerPage=""
        style={{ overflow: 'visible' }}
      />
    </Box>
  );
}

export default EmployeesListing;
